import React, { useState, useEffect } from 'react';

const StoreIssueReportAllPrint = () => {
  const [reportData, setReportData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [params, setParams] = useState({});
  const [grandTotal, setGrandTotal] =useState([]);

  // Get URL parameters
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
      
    const extractedParams = {
      branchID: urlParams.get('branchID') || '',
      storeIssueNo: urlParams.get('storeIssueNo') || '',
      fromDate: urlParams.get('fromDate') || '',
      toDate: urlParams.get('toDate') || '',
      store: urlParams.get('store') || '',
      itemname: urlParams.get('itemname') || '',
      itemcode: urlParams.get('itemcode') || ''
    };
    setParams(extractedParams);
  }, []);


  // Default data structure for fallback
  const defaultReportData = {
    branchName: "",
    dateRange: "",
    items: [],
    grandTotal: "₹0.00",
    totalRecords: 0
  };

  // Fetch data from API
  useEffect(() => {
    const fetchReportData = async () => {
      if (!params.branchID) {
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        
        // Build API URL with parameters
        const apiParams = new URLSearchParams({
          branchID: params.branchID,
          departmentNo: params.departmentNo || '',
          fromDate: params.fromDate || '',
          toDate: params.toDate || '',
          department: params.department || '',
          username: params.username || '',
          usercode: params.usercode || ''
        });
        console.log("param", params);
        const response = await fetch(`http://nissi-india.com/api/storeIssueReport?${apiParams}`);
        
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        
        const res = await response.json();
        console.log("Fetched data:", res);
        
        // Check if API call was successful
        if (!res.success && res.success !== undefined) {
          throw new Error('API returned unsuccessful response');
        }

        // Format date function
        const formatDate = (dateString) => {
          if (!dateString) return '';
          const date = new Date(dateString);
          return date.toLocaleDateString('en-GB');
        };

        // Transform API data to match our component structure
        const apiData = res.data || [];
        setGrandTotal(res.grandTotal
);
        
        
        const transformedData = {
          branchName: apiData[0]?.fld_BranchName || `Branch ID: ${params.branchID}`,
          dateRange: `${formatDate(params.fromDate)} to ${formatDate(params.toDate)}`,
          totalRecords: apiData.length,
          items: apiData.map((item, index) => ({
            sNo: index + 1,
            issueNo: item.fld_storesissueno || "",
            date: item.fld_date || "",
            userName: item.fld_username || "",
            totalValue: item.totalNew ,
            department: item.fld_departmentname || "",
            project: item.fld_projectname || "",
            branch: item.fld_BranchName || "",
            status: item.fld_status || "",
            remarks: item.fld_remarks || ""
          })),
       
        };

        // Calculate grand total
       

        setReportData(transformedData);
        setError(null);
      } catch (err) {
        console.error('Error fetching report data:', err);
        setError(err.message);
        setReportData(defaultReportData);
      } finally {
        setLoading(false);
      }
    };

    fetchReportData();
  }, [params]);

  if (loading) {
    return (
      <div className="max-w-full mx-auto p-6 bg-white font-sans text-sm">
        <div className="flex items-center justify-center h-64">
          <div className="text-center">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
            <p className="text-gray-600">Loading report data...</p>
          </div>
        </div>
      </div>
    );
  }

  if (!reportData) {
    return (
      <div className="max-w-full mx-auto p-6 bg-white font-sans text-sm">
        <div className="flex items-center justify-center h-64">
          <div className="text-center text-red-600">
            <p className="text-lg font-semibold mb-2">Error Loading Report</p>
            <p>{error || "Failed to load report data"}</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="max-w-full mx-auto p-6 bg-white font-sans text-sm">
      {/* API Error Warning (if using fallback data) */}
      {error && (
        <div className="mb-4 p-3 bg-yellow-100 border border-yellow-400 text-yellow-700 rounded no-print">
          <p className="text-sm">
            <strong>Note:</strong> Could not fetch data from API ({error}). Showing template.
          </p>
        </div>
      )}

      {/* Outer Border */}
      <div className="border-4 border-black p-4 print:border-black">
        
        {/* Header Section */}
        <div className="border-2 border-black mb-4 print:border-black">
          <div className="flex items-start p-4">
            {/* Logo Section */}
            <div className="w-32 h-20 border-2 border-black mr-6 flex items-center justify-center bg-white">
              <div className="text-center">
                <div className="w-12 h-8 bg-black mx-auto mb-1 flex items-center justify-center">
                  <span className="text-white text-xs font-bold">LOGO</span>
                </div>
                <div className="text-xs font-bold">NISSI INFOTECH</div>
                <div className="text-xs">PVT LTD</div>
              </div>
            </div>
            
            {/* Company Info */}
            <div className="flex-1 text-center">
              <h1 className="text-xl font-bold mb-1">Nissi Infotech</h1>
              <p className="text-sm mb-1">NISSI</p>
              <p className="text-sm font-bold mb-1">CIVIL CONSTRUCTION</p>
              <p className="text-xs">
                3/42-12, Nagappa colony, kavundampai,644003,Tamil Nadu,India,<br/>
                Phone No :9003744644 infraconsoft-implementation@nissiinfotech.in
              </p>
            </div>
          </div>
        </div>

        {/* Report Title */}
        <div className="text-center border-b-2 border-black pb-2 mb-4 print:border-black">
          <h2 className="text-lg font-bold underline">Department Report</h2>
        </div>

        {/* Report Summary */}
        <div className="grid grid-cols-3 gap-x-8 mb-4 text-sm">
          <div className="space-y-1">
            <div className="flex">
              <span className="font-bold w-24">Branch</span>
              <span className="mr-2">:</span>
              <span>{reportData.branchName}</span>
            </div>
            <div className="flex">
              <span className="font-bold w-24">From</span>
              <span className="mr-2">:</span>
              <span>{params.fromDate || 'N/A'}</span>
            </div>
          </div>
          
          <div className="space-y-1">
            <div className="flex">
              <span className="font-bold w-24">To</span>
              <span className="mr-2">:</span>
              <span>{params.toDate || 'N/A'}</span>
            </div>
            <div className="flex">
              <span className="font-bold w-24">Total</span>
              <span className="mr-2">:</span>
              <span className="font-bold text-green-600">{reportData.grandTotal}</span>
            </div>
          </div>

          <div className="space-y-1">
            {params.departmentNo && (
              <div className="flex">
                <span className="font-bold w-24">Dept No</span>
                <span className="mr-2">:</span>
                <span>{params.departmentNo}</span>
              </div>
            )}
            {(params.username || params.usercode) && (
              <div className="flex">
                <span className="font-bold w-24">User</span>
                <span className="mr-2">:</span>
                <span>{params.username || params.usercode}</span>
              </div>
            )}
          </div>
        </div>

        {/* Items Table */}
        <div className="border-2 border-black mb-4 print:border-black overflow-x-auto">
          <table className="w-full text-xs">
            <thead>
              <tr className="bg-white print:bg-white">
                <th className="border border-black px-1 py-2 text-center w-8 print:border-black">S.No</th>
                <th className="border border-black px-1 py-2 text-center w-24 print:border-black">Issue No</th>
                <th className="border border-black px-1 py-2 text-center w-16 print:border-black">Date</th>
                <th className="border border-black px-1 py-2 text-center w-20 print:border-black">User Name</th>
                <th className="border border-black px-1 py-2 text-center w-20 print:border-black">Total Value</th>
              </tr>
            </thead>
            <tbody>
              {reportData.items.map((item) => (
                <tr key={item.sNo}>
                  <td className="border border-black px-1 py-1 text-center print:border-black">{item.sNo}</td>
                  <td className="border border-black px-1 py-1 text-center print:border-black">{item.issueNo}</td>
                  <td className="border border-black px-1 py-1 text-center print:border-black">{item.date}</td>
                  <td className="border border-black px-1 py-1 text-center print:border-black">{item.userName}</td>
                  <td className="border border-black px-1 py-1 text-right print:border-black">{item.totalValue}</td>
                </tr>
              ))}

              {/* Grand Total Row */}
             
                <tr className="bg-gray-50">
                  <td className="border border-black px-1 py-2 print:border-black font-bold" colSpan="4">
                    <div className="text-center">Total :</div>
                  </td>
                  <td className="border border-black px-1 py-2 text-right font-bold print:border-black text-green-600">
                    {grandTotal}
                  </td>
                </tr>
              

              {/* No Data Message */}
              {reportData.items.length === 0 && (
                <tr>
                  <td className="border border-black px-2 py-8 text-center print:border-black" colSpan="5">
                    <div className="text-gray-500">
                      No records found for the specified criteria
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Footer */}
        <div className="border-2 border-black print:border-black">
          <div className="p-2 text-right text-xs">
            <span className="font-bold">Page 1 of 1</span>
          </div>
          <div className="border-t-2 border-black p-2 text-xs print:border-black">
            Report generated by ERP-Software - www.infraconsoft.com owned by <span className="font-bold">www.nissiinfotech.com</span>
          </div>
        </div>

      </div>

      {/* Control Buttons */}
      <div className="mt-6 text-center no-print">
        <button
          onClick={() => window.print()}
          className="bg-blue-600 text-white px-6 py-2 rounded hover:bg-blue-700 transition-colors mr-4"
        >
          Print Report
        </button>
        <button
          onClick={() => window.location.reload()}
          className="bg-gray-600 text-white px-6 py-2 rounded hover:bg-gray-700 transition-colors mr-4"
        >
          Refresh Data
        </button>
        <button
          onClick={() => window.close()}
          className="bg-red-600 text-white px-6 py-2 rounded hover:bg-red-700 transition-colors"
        >
          Close Window
        </button>
      </div>

      {/* Print Styles */}
      <style jsx>{`
        @media print {
          .no-print {
            display: none !important;
          }
          body {
            margin: 0;
            padding: 10mm;
            background: white !important;
          }
          * {
            color: black !important;
            background: white !important;
            border-color: black !important;
          }
          .print\\:border-black {
            border-color: black !important;
          }
          .print\\:bg-white {
            background-color: white !important;
          }
          table {
            font-size: 10px !important;
          }
          .text-green-600 {
            color: black !important;
          }
        }
      `}</style>
    </div>
  );
};

export default StoreIssueReportAllPrint;